import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormatPipe',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {

  transform(val: number, unit: 's' | 'ms'): unknown {
    return unit === 's'
    ? this.format(val)
    : this.format(Math.floor(val / 1000))

  }

  format(val: number) {
    const hours = Math.floor(val / 3600);
    const withoutHours = val % 3600;
    const minutes = Math.floor(withoutHours / 60);
    const seconds = withoutHours % 60

    const format = (num: number) => `00${num}`.slice(-2);
    const formatHours = format(hours)
    const formatMinutes = format(minutes)
    const formatSeconds = format(seconds)
    return `${formatHours}:${formatMinutes}:${formatSeconds}`;
  }

}
